var moduleMap = {
	"./module": () => {
		return Promise.all([__webpack_require__.e(379), __webpack_require__.e(3888), __webpack_require__.e(8424), __webpack_require__.e(9077), __webpack_require__.e(2494), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(9314), __webpack_require__.e(3136), __webpack_require__.e(1410), __webpack_require__.e(1682), __webpack_require__.e(4681), __webpack_require__.e(6663), __webpack_require__.e(2575), __webpack_require__.e(1758)]).then(() => (() => ((__webpack_require__(78678)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});